import { render, staticRenderFns } from "./igt-range-field.vue?vue&type=template&id=265de67a&scoped=true&"
import script from "./igt-range-field.vue?vue&type=script&lang=js&"
export * from "./igt-range-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265de67a",
  null
  
)

export default component.exports